import {
    AcceptVideoRequestAction,
    AgentVideoRequestAction,
    CloseVideoPanelAction,
    LocalVideoActiveAction,
    RemoteVideoActiveAction,
    RemoteVideoClosedAction,
    RemoteVideoStreamingAction,
    ToggleAudioStreamAction,
    ToggleVideoStreamAction,
    VideoConnectionErrorAction,
} from '../typedefs/actions';
import * as actionTypes from '../typedefs/actionTypes';
import { VideoState as State } from '../typedefs/store';
import { createReducer } from './util';

const initialState: State = {};

const handlers = {
    [actionTypes.SOCKET_EVENT_CLIENT_VIDEO_REQUEST]: videoRequestReceived,
    [actionTypes.ACCEPT_VIDEO_REQUEST]: acceptVideoRequest,
    [actionTypes.LOCAL_VIDEO_ACTIVE]: localVideoActive,
    [actionTypes.REMOTE_VIDEO_ACTIVE]: remoteVideoActive,
    [actionTypes.REMOTE_VIDEO_STREAMING]: remoteVideoStreaming,
    [actionTypes.REMOTE_VIDEO_CLOSED]: remoteVideoClosed,
    [actionTypes.VIDEO_CONNECTION_ERROR]: videoConnectionError,
    [actionTypes.CLOSE_VIDEO_PANEL]: closeVideoPanel,
    [actionTypes.TOGGLE_AUDIO_STREAM]: toggleAudioStream,
    [actionTypes.TOGGLE_VIDEO_STREAM]: toggleVideoStream,
};

function videoRequestReceived(state: State, action: AgentVideoRequestAction): State {
    return {
        ...state,
        request: {
            timestamp: new Date().toISOString(),
            peerId: action.payload.peerId,
            agentId: extractAgentIdFromPeerId(action.payload.peerId),
            iceServers: action.payload.iceServers,
            accepted: false,
        },
    };
}

const extractAgentIdFromPeerId = (peerId: string) => {
    return parseInt(peerId.substr(peerId.indexOf('A') + 1), 10);
};

function acceptVideoRequest(state: State, action: AcceptVideoRequestAction): State {
    if (!state.request) return state;
    return {
        ...state,
        localActive: false,
        remoteActive: false,
        remoteStreaming: false,
        remoteClosed: false,
        connectionError: false,
        audioMuted: false,
        videoMuted: false,
        request: { ...state.request, accepted: true },
    };
}

function localVideoActive(state: State, action: LocalVideoActiveAction): State {
    return { ...state, localActive: action.payload.value };
}

function remoteVideoActive(state: State, action: RemoteVideoActiveAction): State {
    return { ...state, remoteActive: action.payload.value };
}

function remoteVideoStreaming(state: State, action: RemoteVideoStreamingAction): State {
    return { ...state, remoteStreaming: action.payload.value };
}

function remoteVideoClosed(state: State, action: RemoteVideoClosedAction): State {
    return { ...state, remoteClosed: true };
}

function videoConnectionError(state: State, action: VideoConnectionErrorAction): State {
    return { ...state, connectionError: true };
}

function closeVideoPanel(state: State, action: CloseVideoPanelAction): State {
    return { ...state, request: undefined };
}

function toggleAudioStream(state: State, action: ToggleAudioStreamAction): State {
    return { ...state, audioMuted: !state.audioMuted };
}

function toggleVideoStream(state: State, action: ToggleVideoStreamAction): State {
    return { ...state, videoMuted: !state.videoMuted };
}

export default createReducer(initialState, handlers);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/video.ts